<template>
  <div class="content-body">
    <h6 v-if="showResetField">
      Email sa reset kodom je poslat na {{ email }}. Ukoliko niste dobili email
      molimo Vas da proverite Vaš spam folder.
    </h6>
    <form @submit.prevent="submitForm">
      <div v-if="!mailAndCodeSent">
        <label class="col-form-label col-form-label-lg">Email</label>
        <input
          type="email"
          class="form-control form-control-lg reset-class"
          placeholder="Unesite svoj email"
          v-model="email"
          @focus="errorOccurred = false"
        />
        <div v-if="showResetField">
          <label class="col-form-label col-form-label-lg">Reset kod</label>
          <input
            type="text"
            class="form-control form-control-lg reset-class"
            placeholder="Unesite reset kod koji Vam je stigao na e-mail"
            v-model="resetCode"
            @focus="errorOccurred = false"
          />
        </div>
      </div>
      <div v-if="mailAndCodeSent">
        <label class="col-form-label col-form-label-lg">Lozinka</label>
        <input
          type="password"
          class="form-control form-control-lg reset-class"
          placeholder="Unesite novu lozinku"
          v-model="password1"
          @focus="errorOccurred = false"
        />
        <label class="col-form-label col-form-label-lg"
          >Ponovljena lozinka</label
        >
        <input
          type="password"
          class="form-control form-control-lg reset-class"
          placeholder="Ponovite lozinku"
          v-model="password2"
          @focus="errorOccurred = false"
        />
      </div>

      <div class="footer">
        <div class="error">
          <transition enter-active-class="animated shake">
            <p class="error-msg" v-if="errorOccurred">{{ errorMessage }}</p>
          </transition>
        </div>
        <div class="buttons">
          <button class="btn btn-danger btn--mod" @click.prevent="closeModal">
            Otkaži
          </button>
          <button type="submit" class="btn btn-primary btn--mod">
            Potvrdi
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from '@/axios/axios.js';
import { mapMutations } from 'vuex';
export default {
  data() {
    return {
      email: '',
      errorOccurred: false,
      errorMessage: '',
      showResetField: false,
      resetCode: '',
      emailSent: false,
      mailAndCodeSent: false,
      password1: '',
      password2: ''
    };
  },
  methods: {
    ...mapMutations('modal', ['closeModal']),
    submitForm() {
      if (this.mailAndCodeSent) {
        if (!this.validatePassword()) {
          this.errorOccurred = true;
          return;
        }

        this.submitNewPassword();
      } else if (!this.emailSent) {
        if (!this.validateMail()) {
          this.errorOccurred = true;
          return;
        }
        this.submitMail();
      } else {
        if (!this.validateMailandCode()) {
          this.errorOccurred = true;
          return;
        }
        this.submitMailAndCode();
      }
    },
    validateMail() {
      this.errorOccurred = false;

      if (this.email.length == 0) {
        this.errorMessage = 'Morate uneti email';
        return false;
      }
      return true;
    },
    validateMailandCode() {
      this.errorOccurred = false;

      if (this.resetCode.length == 0 || !this.validateMail()) {
        this.errorMessage = 'Morate uneti email i kod';
        return false;
      }
      return true;
    },
    validatePassword() {
      this.errorOccurred = false;

      if (this.password1.length == 0 || this.password2.length == 0) {
        this.errorMessage = 'Morate uneti password';
        return false;
      }
      return true;
    },
    submitMail() {
      let emailData = { email: this.email };
      axios
        .post('/user/restart-password', emailData)
        .then(() => {
          this.emailSent = true;
          this.showResetField = true;
        })
        .catch(error => {
          this.errorOccurred = true;
          if (error.response) {
            console.log(error);
            if (error.response.status >= 500) {
              this.errorMessage = 'Greška na serveru. Pokušajte kasnije.';
            }
            if (error.response.status == 404) {
              this.errorMessage = 'Ne postoji korisnik sa datim e-mailom.';
            }
          } else {
            this.errorMessage =
              'Server trenutno nije dostupan. Pokušajte kasnije.';
          }
        });
    },
    submitMailAndCode() {
      let codeData = { email: this.email, code: this.resetCode };
      axios
        .post('/user/login-with-reset-code', codeData)
        .then(() => {
          this.mailAndCodeSent = true;
        })
        .catch(error => {
          this.errorOccurred = true;

          if (error.response.status) {
            let responseText = JSON.parse(error.response.request.responseText);
            if (error.response.status >= 500) {
              this.errorMessage = 'Greška na serveru. Pokušajte kasnije.';
            }
            if (error.response.status == 401) {
              this.errorMessage = responseText.messages;
            }
            if (error.response.status == 404) {
              this.errorMessage = responseText.messages;
            }
          } else {
            this.errorMessage =
              'Server trenutno nije dostupan. Pokušajte kasnije.';
          }
        });
    },
    submitNewPassword() {
      if (this.password1 != this.password2) {
        this.errorOccurred = true;
        this.errorMessage = 'Ne poklapaju se lozinke';
        return;
      }
      let passData = {
        email: this.email,
        code: this.resetCode,
        password: this.password1
      };
      axios
        .post('/user/set-new-password', passData)
        .then(() => {
          this.closeModal();
        })
        .catch(error => {
          this.errorOccurred = true;

          if (error.response.status) {
            if (error.response.status >= 500) {
              this.errorMessage = 'Greška na serveru. Pokušajte kasnije.';
            }
          } else {
            this.errorMessage =
              'Server trenutno nije dostupan. Pokušajte kasnije.';
          }
        });
    }
  }
};
</script>

<style scoped>
.reset-class {
  margin-bottom: 9px;
}

.error-msg {
  width: 100%;
  color: red;
  float: left;
  margin-top: 15px;
}

.footer {
  display: block;
  width: 100%;
}

.error {
  float: left;
}
.buttons {
  float: right;
}
</style>
